import { path } from 'ramda';

import { apiErrorActionCreator } from '../common/apiErrorAction';

export const FETCH_COMMENTS_REQUEST = 'FETCH_COMMENTS_REQUEST';
export const FETCH_COMMENTS_SUCCESS = 'FETCH_COMMENTS_SUCCESS';
export const FETCH_COMMENTS_FAILURE = 'FETCH_COMMENTS_FAILURE';

export const FETCH_PARENT_COMMENTS_REQUEST = 'FETCH_PARENT_COMMENTS_REQUEST';
export const FETCH_PARENT_COMMENTS_SUCCESS = 'FETCH_PARENT_COMMENTS_SUCCESS';
export const FETCH_PARENT_COMMENTS_FAILURE = 'FETCH_PARENT_COMMENTS_FAILURE';

export const FETCH_CHILD_COMMENTS_ITERATOR_REQUEST =
  'FETCH_CHILD_COMMENTS_ITERATOR_REQUEST';
export const FETCH_CHILD_REPLIES_COMMENTS_REQUEST =
  'FETCH_CHILD_REPLIES_COMMENTS_REQUEST';
export const FETCH_CHILD_COMMENTS_REQUEST = 'FETCH_CHILD_COMMENTS_REQUEST';
export const FETCH_CHILD_COMMENTS_SUCCESS = 'FETCH_CHILD_COMMENTS_SUCCESS';
export const CANCEL_CHILD_COMMENTS_REQUEST = 'CANCEL_CHILD_COMMENTS_REQUEST';
export const FETCH_CHILD_COMMENTS_FAILURE = 'FETCH_CHILD_COMMENTS_FAILURE';

export const REPORT_COMMENT_REQUEST = 'REPORT_COMMENT_REQUEST';
export const REPORT_COMMENT_SUCCESS = 'REPORT_COMMENT_SUCCESS';
export const REPORT_COMMENT_FAILURE = 'REPORT_COMMENT_FAILURE';

export const REPORT_REPLY_REQUEST = 'REPORT_REPLY_REQUEST';
export const REPORT_REPLY_SUCCESS = 'REPORT_REPLY_SUCCESS';
export const REPORT_REPLY_FAILURE = 'REPORT_REPLY_FAILURE';

export const LIKE_COMMENT_REQUEST = 'LIKE_COMMENT_REQUEST';
export const LIKE_COMMENT_SUCCESS = 'LIKE_COMMENT_SUCCESS';
export const LIKE_COMMENT_FAILURE = 'LIKE_COMMENT_FAILURE';

export const UNLIKE_COMMENT_REQUEST = 'UNLIKE_COMMENT_REQUEST';
export const UNLIKE_COMMENT_SUCCESS = 'UNLIKE_COMMENT_SUCCESS';
export const UNLIKE_COMMENT_FAILURE = 'UNLIKE_COMMENT_FAILURE';

export const LIKE_CHILD_COMMENT_REQUEST = 'LIKE_CHILD_COMMENT_REQUEST';
export const LIKE_CHILD_COMMENT_SUCCESS = 'LIKE_CHILD_COMMENT_SUCCESS';
export const LIKE_CHILD_COMMENT_FAILURE = 'LIKE_CHILD_COMMENT_FAILURE';

export const UNLIKE_CHILD_COMMENT_REQUEST = 'UNLIKE_CHILD_COMMENT_REQUEST';
export const UNLIKE_CHILD_COMMENT_SUCCESS = 'UNLIKE_CHILD_COMMENT_SUCCESS';
export const UNLIKE_CHILD_COMMENT_FAILURE = 'UNLIKE_CHILD_COMMENT_FAILURE';

export const POST_COMMENT_REQUEST = 'POST_COMMENT_REQUEST';
export const POST_COMMENT_SUCCESS = 'POST_COMMENT_SUCCESS';
export const POST_COMMENT_FAILURE = 'POST_COMMENT_FAILURE';

export const POST_REPLY_REQUEST = 'POST_REPLY_REQUEST';
export const POST_REPLY_SUCCESS = 'POST_REPLY_SUCCESS';
export const POST_REPLY_FAILURE = 'POST_REPLY_FAILURE';

export const DELETE_COMMENT_REQUEST = 'DELETE_COMMENT_REQUEST';
export const DELETE_COMMENT_FAILURE = 'DELETE_COMMENT_FAILURE';
export const DELETE_COMMENT_SUCCESS = 'DELETE_COMMENT_SUCCESS';

export const DELETE_REPLY_REQUEST = 'DELETE_REPLY_REQUEST';
export const DELETE_REPLY_FAILURE = 'DELETE_REPLY_FAILURE';
export const DELETE_REPLY_SUCCESS = 'DELETE_REPLY_SUCCESS';

export const TOGGLE_COMMENT_EDITING = 'TOGGLE_COMMENT_EDITING';

export const EDIT_PARENT_REQUEST = 'EDIT_PARENT_REQUEST';
export const EDIT_PARENT_SUCCESS = 'EDIT_PARENT_SUCCESS';
export const EDIT_PARENT_FAILURE = 'EDIT_PARENT_FAILURE';

export const EDIT_CHILD_REQUEST = 'EDIT_CHILD_REQUEST';
export const EDIT_CHILD_SUCCESS = 'EDIT_CHILD_SUCCESS';
export const EDIT_CHILD_FAILURE = 'EDIT_CHILD_FAILURE';

export const CLEAR_POST_COMMENT_ERROR = 'CLEAR_POST_COMMENT_ERROR';
export const CLEAR_POST_REPLY_ERROR = 'CLEAR_POST_REPLY_ERROR';
export const CLEAR_EDIT_COMMENT_ERROR = 'CLEAR_EDIT_COMMENT_ERROR';

// Parent comment load more actions
export const LOAD_MORE_PARENT_COMMENTS_REQUEST =
  'LOAD_MORE_PARENT_COMMENTS_REQUEST';
export const LOAD_MORE_PARENT_COMMENTS_SUCCESS =
  'LOAD_MORE_PARENT_COMMENTS_SUCCESS';
export const LOAD_MORE_PARENT_COMMENTS_FAILURE =
  'LOAD_MORE_PARENT_COMMENTS_FAILURE';

// Children load more comments actions
export const LOAD_MORE_CHILDREN_COMMENTS_REQUEST =
  'LOAD_MORE_CHILDREN_COMMENTS_REQUEST';
export const LOAD_MORE_CHILDREN_COMMENTS_SUCCESS =
  'LOAD_MORE_CHILDREN_COMMENTS_SUCCESS';
export const LOAD_MORE_CHILDREN_COMMENTS_FAILURE =
  'LOAD_MORE_CHILDREN_COMMENTS_FAILURE';

export const fetchCommentsRequest = (contentId) => ({
  type: FETCH_COMMENTS_REQUEST,
  payload: {
    contentId
  }
});

export const fetchCommentsSuccess = ({ comments }) => ({
  type: FETCH_COMMENTS_SUCCESS,
  payload: {
    comments
  }
});

export const fetchCommentsFailure = (response) =>
  apiErrorActionCreator(FETCH_COMMENTS_FAILURE)(response, {
    errorType: FETCH_COMMENTS_FAILURE
  });

export const fetchParentCommentsRequest = ({ contentId, communityIds }) => ({
  type: FETCH_PARENT_COMMENTS_REQUEST,
  payload: {
    contentId,
    communityIds
  }
});

export const fetchParentCommentsSuccess = ({ comments, isLastPage }) => ({
  type: FETCH_PARENT_COMMENTS_SUCCESS,
  payload: {
    comments,
    isLastPage
  }
});

export const fetchParentCommentsFailure = (response) =>
  apiErrorActionCreator(FETCH_PARENT_COMMENTS_FAILURE)(response, {
    errorType: FETCH_PARENT_COMMENTS_FAILURE
  });

export const fetchChildCommentsIteratorRequest = ({
  contentId,
  parentIds
}) => ({
  type: FETCH_CHILD_COMMENTS_ITERATOR_REQUEST,
  payload: {
    contentId,
    parentIds
  }
});

export const fetchChildCommentsRequest = ({ contentId, parentId }) => ({
  type: FETCH_CHILD_COMMENTS_REQUEST,
  payload: {
    contentId,
    parentId
  }
});

export const cancelChildCommentsRequest = ({ parentId }) => ({
  type: CANCEL_CHILD_COMMENTS_REQUEST,
  payload: {
    parentId
  }
});

export const fetchChildCommentsSuccess = ({
  childComments,
  parentId,
  isLastPage,
  totalCount
}) => ({
  type: FETCH_CHILD_COMMENTS_SUCCESS,
  payload: {
    childComments,
    parentId,
    isLastPage,
    totalCount
  }
});

export const fetchChildCommentsFailure = (response, { parentId }) =>
  apiErrorActionCreator(FETCH_CHILD_COMMENTS_FAILURE)(response, { parentId });

export const reportCommentRequest = ({ contentId, commentId }) => ({
  type: REPORT_COMMENT_REQUEST,
  payload: {
    contentId,
    commentId
  }
});

export const reportCommentSuccess = (commentId) => ({
  type: REPORT_COMMENT_SUCCESS,
  payload: {
    commentId
  }
});

export const reportCommentFailure = (response) =>
  apiErrorActionCreator(REPORT_COMMENT_FAILURE)(response);

export const reportReplyRequest = ({ contentId, commentId, rootId }) => ({
  type: REPORT_REPLY_REQUEST,
  payload: {
    contentId,
    commentId,
    rootId
  }
});

export const reportReplySuccess = ({ rootId, commentId }) => ({
  type: REPORT_REPLY_SUCCESS,
  payload: {
    commentId,
    rootId
  }
});

export const reportReplyFailure = (response) =>
  apiErrorActionCreator(REPORT_REPLY_FAILURE)(response);

export const likeCommentRequest = ({ contentId, commentId }) => ({
  type: LIKE_COMMENT_REQUEST,
  payload: {
    contentId,
    commentId
  }
});

export const likeCommentSuccess = (commentId) => ({
  type: LIKE_COMMENT_SUCCESS,
  payload: {
    commentId
  }
});

export const likeCommentFailure = (response, commentId) => {
  const { metricsInfo, status, problem, config: { method } = {} } = response;
  // If any nested properties are undefined,
  // message will be undefined and
  // the property will not be added.
  const message = path(['data', 'errors', 'base'], response);
  return {
    type: LIKE_COMMENT_FAILURE,
    payload: {
      commentId,
      response: {
        status,
        problem,
        method,
        message,
        metricsInfo
      }
    }
  };
};

export const likeChildCommentRequest = ({
  parentId,
  contentId,
  commentId
}) => ({
  type: LIKE_CHILD_COMMENT_REQUEST,
  payload: {
    parentId,
    contentId,
    commentId
  }
});

export const likeChildCommentSuccess = ({ parentId, commentId }) => ({
  type: LIKE_CHILD_COMMENT_SUCCESS,
  payload: {
    parentId,
    commentId
  }
});

export const likeChildCommentFailure = (response, commentId, parentId) =>
  apiErrorActionCreator(LIKE_CHILD_COMMENT_FAILURE)(response, {
    parentId,
    commentId
  });

export const unlikeCommentRequest = ({ contentId, commentId }) => ({
  type: UNLIKE_COMMENT_REQUEST,
  payload: {
    contentId,
    commentId
  }
});

export const unlikeCommentSuccess = () => ({
  type: UNLIKE_COMMENT_SUCCESS
});

export const unlikeCommentFailure = (response, commentId) =>
  apiErrorActionCreator(UNLIKE_COMMENT_FAILURE)(response, { commentId });

export const unlikeChildCommentRequest = ({
  contentId,
  parentId,
  commentId
}) => ({
  type: UNLIKE_CHILD_COMMENT_REQUEST,
  payload: {
    parentId,
    contentId,
    commentId
  }
});

export const unlikeChildCommentSuccess = () => ({
  type: UNLIKE_CHILD_COMMENT_SUCCESS
});

export const unlikeChildCommentFailure = (response, commentId, parentId) =>
  apiErrorActionCreator(UNLIKE_CHILD_COMMENT_FAILURE)(response, {
    parentId,
    commentId
  });

export const postCommentRequest = ({
  contentId,
  commentText,
  communityId = null,
  parentId = null
}) => {
  return {
    type: POST_COMMENT_REQUEST,
    payload: {
      contentId,
      commentText,
      communityId,
      parentId
    }
  };
};

export const postCommentSuccess = (comment, commentsContext) => {
  return {
    type: POST_COMMENT_SUCCESS,
    payload: {
      comment,
      commentsContext
    }
  };
};

export const postCommentFailure = (response) =>
  apiErrorActionCreator(POST_COMMENT_FAILURE)(response, {
    errorType: POST_COMMENT_FAILURE
  });

export const postReplyRequest = ({
  contentId,
  commentText,
  communityId = null,
  parentId = null,
  rootId = null
}) => {
  return {
    type: POST_REPLY_REQUEST,
    payload: {
      contentId,
      commentText,
      communityId,
      parentId,
      rootId
    }
  };
};

export const postReplySuccess = (reply, commentsContext) => {
  return {
    type: POST_REPLY_SUCCESS,
    payload: {
      reply,
      commentsContext
    }
  };
};

export const postReplyFailure = (response, rootId) =>
  apiErrorActionCreator(POST_REPLY_FAILURE)(response, {
    rootId
  });

export const deleteCommentRequest = ({ contentId, commentId }) => {
  return {
    type: DELETE_COMMENT_REQUEST,
    payload: {
      contentId,
      commentId
    }
  };
};

export const deleteCommentFailure = ({ commentId }) => {
  return {
    type: DELETE_COMMENT_FAILURE,
    payload: {
      commentId
    }
  };
};

export const deleteCommentSuccess = (comment) => {
  return {
    type: DELETE_COMMENT_SUCCESS,
    payload: {
      comment
    }
  };
};

export const deleteReplyRequest = ({ contentId, commentId, rootId = null }) => {
  return {
    type: DELETE_REPLY_REQUEST,
    payload: {
      contentId,
      commentId,
      rootId
    }
  };
};

export const deleteReplyFailure = ({ commentId, rootId = null }) => {
  return {
    type: DELETE_REPLY_FAILURE,
    payload: {
      commentId,
      rootId
    }
  };
};

export const deleteReplySuccess = (reply, rootId = null) => {
  return {
    type: DELETE_REPLY_SUCCESS,
    payload: {
      reply,
      rootId
    }
  };
};

export const toggleCommentEditing = ({ commentId, rootId }) => ({
  type: TOGGLE_COMMENT_EDITING,
  payload: {
    commentId,
    rootId
  }
});

export const editParentRequest = ({ commentId, contentId, commentText }) => ({
  type: EDIT_PARENT_REQUEST,
  payload: {
    commentId,
    contentId,
    commentText
  }
});

export const editParentSuccess = (comment) => ({
  type: EDIT_PARENT_SUCCESS,
  payload: {
    comment
  }
});

export const editParentFailure = (commentId) => ({
  type: EDIT_PARENT_FAILURE,
  payload: {
    commentId
  }
});

export const editChildRequest = ({
  commentId,
  contentId,
  commentText,
  rootId
}) => ({
  type: EDIT_CHILD_REQUEST,
  payload: {
    commentId,
    contentId,
    rootId,
    commentText
  }
});

export const editChildSuccess = (comment) => ({
  type: EDIT_CHILD_SUCCESS,
  payload: {
    comment
  }
});

export const editChildFailure = ({ commentId, rootId }) => ({
  type: EDIT_CHILD_FAILURE,
  payload: {
    commentId,
    rootId
  }
});

export const clearPostCommentError = () => ({
  type: CLEAR_POST_COMMENT_ERROR
});

export const clearPostReplyError = (rootId) => ({
  type: CLEAR_POST_REPLY_ERROR,
  payload: {
    rootId
  }
});

export const clearEditCommentError = (commentId, parentId) => ({
  type: CLEAR_EDIT_COMMENT_ERROR,
  payload: {
    parentId,
    commentId
  }
});

export const loadMoreParentCommentsRequest = (
  contentId,
  timestamp,
  communityIds
) => ({
  type: LOAD_MORE_PARENT_COMMENTS_REQUEST,
  payload: {
    contentId,
    timestamp,
    communityIds
  }
});

export const loadMoreParentCommentsSuccess = ({ comments, isLastPage }) => ({
  type: LOAD_MORE_PARENT_COMMENTS_SUCCESS,
  payload: {
    comments,
    isLastPage
  }
});

export const loadMoreParentCommentsFailure = (response) =>
  apiErrorActionCreator(LOAD_MORE_PARENT_COMMENTS_FAILURE)(response, {
    errorType: LOAD_MORE_PARENT_COMMENTS_FAILURE
  });

export const loadMoreChildrenCommentsRequest = (
  contentId,
  timestamp,
  parentId
) => ({
  type: LOAD_MORE_CHILDREN_COMMENTS_REQUEST,
  payload: {
    contentId,
    timestamp,
    parentId
  }
});

export const loadMoreChildrenCommentsSuccess = ({
  comments,
  parentId,
  isLastPage
}) => ({
  type: LOAD_MORE_CHILDREN_COMMENTS_SUCCESS,
  payload: {
    comments,
    parentId,
    isLastPage
  }
});

export const loadMoreChildrenCommentsFailure = (response, { parentId }) =>
  apiErrorActionCreator(LOAD_MORE_CHILDREN_COMMENTS_FAILURE)(response, {
    parentId
  });
